import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { SentDialogComponent } from '../contract-signing/sent-dialog/sent-dialog.component';

@Component({
  selector: 'app-draft-warning',
  templateUrl: './draft-warning.component.html',
  styleUrls: ['./draft-warning.component.scss']
})
export class DraftWarningComponent {
  constructor(public dialogRef: MatDialogRef<SentDialogComponent>) { }

  public closeDialog(): void {
    this.dialogRef.close();
  }
}
